import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';


const Email = () => {
  const navigate = useNavigate();

  useEffect(() => {
    
    navigate('/fileimage');
  }, [navigate]);

  return (
    <div className="segment-container">
      
    </div>
  );
};

export default Email;